import { useSelector, useDispatch } from 'react-redux';
import { Divider } from 'palette/Divider';
import { List, ListItem } from 'palette/List';
import { Toggle } from 'palette/Toggle';
import { GA_FILTER_SORTING_ACTION, GA_FILTERS_SORTING_CATEGORY } from '@common/Tracking';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';
import { selectSortOrder } from '../actions/sortByActions';
import '../styles/SortBy.scss';

function SortBy({ topLabel }) {
    const dispatch = useDispatch();
    const sortBy = useSelector(state => state.sortBy);

    const isOrderActive = sortBy.some(orderItem => orderItem.selected);
    const isOrderSelected = order => (!isOrderActive && order.value === '-1') || order.selected;

    const handleClick = (e, value) => {
        e.preventDefault();
        const sortValue = value ?? e.currentTarget.getAttribute('data-value');
        dispatch(selectSortOrder(sortValue));
        pushGAEventToDataLayer(GA_FILTERS_SORTING_CATEGORY, GA_FILTER_SORTING_ACTION, sortValue);
    };

    return (
        <List>
            <ListItem
                label={topLabel}
                labelType="large-title"
            />
            <Divider />
            {
                sortBy.map((order) => {
                    const { value, selected, label } = order;
                    return (
                        <ListItem
                            key={value}
                            isActive={isOrderSelected(order)}
                            {...!selected && {
                                onClick: (e) => { handleClick(e, value === '-1' ? 'popular' : value); }
                            }}
                        >
                            <Toggle
                                id={value === '-1' ? 'popular' : value}
                                isChecked={isOrderSelected(order)}
                                label={label}
                                variant="radio"
                            />
                        </ListItem>
                    );
                })
            }
        </List>
    );
}

export default SortBy;
